// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bbc904fa","453":"5812a206","667":"0786a9aa","977":"d62ad50a"}[chunkId] + ".chunk.js";
};